import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

export type PlaidLinkAccount = {
  id: string;
  mask?: string;
  name?: string;
  subtype?: string;
};

type Variables = {
  accountId: string;
  publicToken: string;
  linkSessionId?: string;
  accountIds?: string[];
  institutionName?: string;
  institutionId?: string;
  accounts?: PlaidLinkAccount[];
};

export type PlaidPaymentMethodRead = {
  id: number;
  last_4_digits?: string;
  institution_name?: string;
};

type Data = PlaidPaymentMethodRead[];

export const connectPlaidPaymentMethods = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.post<Data, AxiosResponse<Data>>(
    `/plaid/payment-methods/${variables.accountId}`,
    {
      public_token: variables.publicToken,
      link_session_id: variables.linkSessionId,
      account_ids: variables.accountIds,
      institution_name: variables.institutionName,
      institution_id: variables.institutionId,
      accounts: variables.accounts,
    }
  );
  return result.data;
};

export const useConnectPlaidPaymentMethods = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useBaseMutation(connectPlaidPaymentMethods, {
    ...options,
    prefixKeysToReset: (data, variables) => [["wallet", variables.accountId]],
  });
};
